


export const uiContent = {
    annoTagsTitle: "Annotation Tags",
    tagsTitle: "Document Tags",
    tagsFilterTitle: "Filter for"
  };
  